import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";
import { Node } from "../../src/shell/Actions/Action";
import { endReplay } from "../../src/shell/endReplay";
import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { ann } from "../characters/Ann";
import { emily } from "../characters/Emily";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { stranger } from "../characters/Stranger";
import { strangerFemale } from "../characters/StrangerFemale";
import { doImageShake, doTransition, doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V8AnnCorruptionLibraryAfter } from "./V8";

const v8 = images.v8;
export const V8AnnCorruptionLibrary = async (): Promise<any> => {
    doTransition(images.v8.V8AnnCorruptionLibrary_47);
    ann.talk(`The library...?`);
    mc.talk(`Yup!`);
    mc.talk(`What better place than a place full of nerds?`);
    ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_48);
    ann.talk(`Hey!`);
    ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_49);
    mc.talk(`Are you saying you're a nerd?`);
    ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_50);
    ann.talk(`No!`);
    ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_49);
    mc.talk(`Right now you are a queen here.`);

    ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_51);
    ann.talk(`But... People might recognize me.`);
    mc.talk(`Are you ashamed of something?`);
    ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_49);
    ann.talk(`No.`);
    mc.talk(`So what's the problem?`);
    ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_50);
    ann.talk(`You're right.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_49);
    mc.talk(`Great! Let's sit down.`);

    return jump(V8AnnCorruptionLibrary_Sitting, "V8AnnCorruptionLibrary_Sitting");
};
export const V8AnnCorruptionLibrary_Sitting = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8AnnCorruptionLibrary_0);

    mc.talk(`So, remember when I said that you need to learn to stay in control and avoid distractions?`);
    ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_52);
    ann.talk(`I do.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_54);
    mc.talk(`So another big thing is learning to improvise...`);

    ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_53);
    ann.talk(`I'm in!`);
    ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_54);
    mc.talk(`You are excited and you didn't even know what I'm suggesting.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_52);
    ann.talk(`Hehe, because I'm feeling like I'm learning a lot.`);
    doWaitImageByTime(images.v8.V8AnnCorruptionLibrary_54);
    mc.think(`Let's see what we can work with...`);
    mc.think(`Ann should do something that she's never done before...`);

    if (Question.globalAnswers.v1EnableNTR) {
        doWaitImageByTime(v8.V8AnnCorruptionLibrary_1);
        mc.think(`There is this guy...`);
        mc.think(`Ann is a sexy girl... At this point I bet she's used to guys hitting on her.`);
        mc.think(`Maybe I can get her to tease him a bit to see how far she can take it.`);
        mc.think(`Or maybe! I can go for something that will really get her out of her shell.`);
        doWaitImageByTime(v8.V8AnnCorruptionLibrary_32);
    } else {
        mc.think(`Oh! What's that?`);
        doWaitImageByTime(v8.V8AnnCorruptionLibrary_32);
        mc.think(`This girl is sitting by herself...`);
    }
    mc.think(`I can tell her to try to hit on that girl and see how well she is doing...`);
    mc.think(`It's definitely going to be interesting!`);

    if (!Question.globalAnswers.v1EnableNTR) {
        return jump(V8AnnCorruptionLibrary_PickedGirl, "V8AnnCorruptionLibrary_PickedGirl");
    }

    doWaitImageByTime(v8.V8AnnCorruptionLibrary_decision);
    await mc.setQuestion(new Question({ text: `Who should I pick...`, options: { think: true }, key: `v8AnnCorLibraryWhoPicked` })
        .option({ title: `Pick the guy`, key: `guy` })
        .option({ title: `Pick the girl`, key: `girl` }));


    if (Question.globalAnswers.v8AnnCorLibraryWhoPicked === "guy") {
        return jump(V8AnnCorruptionLibrary_PickedGuy, "V8AnnCorruptionLibrary_PickedGuy");
    }



    return jump(V8AnnCorruptionLibrary_PickedGirl, "V8AnnCorruptionLibrary_PickedGirl");
};

export const V8AnnCorruptionLibrary_PickedGuy = async (): Promise<any> => {
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_0);
    mc.talk(`So this is what you should do.`);
    ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_1);
    mc.talk(`See that guy over there?`);
    ann.talk(`What about him?`);
    mc.talk(`You should go and hit on him.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_55);
    ann.talk(`What? Are you serious?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_56);
    mc.talk(`It's the perfect opportunity for you to improvise and see if you can convince him that you are really into him.`);

    mc.talk(`Now the roles are reversed. You are the hot girl that should pick up a nerdy guy.`);
    mc.talk(`Just try to put yourself in his shoes and think what will get him going.`);

    ImageClass.setImage(v8.V8AnnCorruptionLibrary_55);
    ann.talk(`Wow, I didn't expected that.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_56);
    mc.talk(`Are you backing down?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_57);
    ann.talk(`No! I can do it! I just need a minute to think.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_56);
    mc.talk(`The whole point is you not thinking and just DO.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_58);
    ann.talk(`But... What if he is into me?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_59);
    ann.talk(`How do I know when to stop or to keep pushing?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_56);
    mc.talk(`Easy.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_60);
    empty.think(`*Click*`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_61);
    ann.talk(`Oh!!!`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_62);
    ann.talk(`I can't believe I almost forgot I have this thing inside of me.`);

    ImageClass.setImage(v8.V8AnnCorruptionLibrary_53);
    ann.talk(`Ok, I think I'm ready.`);
    mc.talk(`Good luck!`);
    await stranger.set((properties) => {
        stranger.name = "Nerd Guy";
    });
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_2, { wait: true });
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_3);
    ann.talk(`Ahem.`);
    stranger.talk(`...`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_4);
    ann.talk(`Ahem!!!`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_6);
    stranger.talk(`C-Can I help you?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_5);
    ann.talk(`Hey. What's your name?`);
    await stranger.set((properties) => {
        stranger.name = "Melvin";
    });
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_6);
    stranger.talk(`${stranger.name}.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_5);
    ann.talk(`Hey ${stranger.name}, my name is Ann.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_6);
    stranger.talk(`H-Hey...`);
    mc.think(`She needs to understand I want more than just chit chat.`);
    mc.think(`Let's encourage her.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_63);
    empty.think(`*Click*`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_64);
    ann.talk(`Oh!!!`);
    // TODO: convo variations
    stranger.talk(`Excuse me?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_65);
    ann.talk(`Sorry, I sneezed.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_6);
    stranger.talk(`Bless you.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_5);
    ann.talk(`Thanks...`);

    ann.talk(`...`);
    ann.talk(`So... What are you doing?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_7);
    stranger.talk(`Me? Huh? Nothing!`);
    stranger.talk(`I mean! I... I- I'm looking for a book.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_66);
    stranger.talk(`Yes, a book! That's what I'm looking for.`);
    ann.talk(`You seem pretty smart, I would have figured you wouldn't need any books.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_7);
    stranger.talk(`Yes, I mean no, I know some stuff, but I- I need to learn.`);

    ann.talk(`Did anyone tell you that you are extremely hot?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_67);
    stranger.talk(`Yes! Yes! My Mom and my sister.`);
    stranger.talk(`I mean, not hot, but they said I have pretty good hairline.`);

    await mc.setQuestion(new Question({ text: `It looks like Ann got the hang of it... But I can encourage her to see where it goes...`, options: { think: true }, key: `v8AnnCorLibraryBJNerdGuy` })
        .option({ title: `Hit the buzzer`, key: true })
        .option({ title: `Don't hit the buzzer`, key: false }));

    if (Question.globalAnswers.v8AnnCorLibraryBJNerdGuy) {
        return jump(V8AnnCorruptionLibrary_PickedGuy_Encourage, "V8AnnCorruptionLibrary_PickedGuy_Encourage");

    }

    ann.talk(`That's cool!`);
    stranger.talk(`Anyway! I-I have to study! Yes Study!`);
    ann.talk(`But we didn't really get the chance to get to know each other.`);
    await endReplay();

    return jump(V8AnnCorruptionLibrary_AfterPicking, "V8AnnCorruptionLibrary_AfterPicking");
};
export const V8AnnCorruptionLibrary_PickedGuy_Encourage = async (): Promise<any> => {
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_63);
    empty.think(`*Click*`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_64);
    ann.talk(`Oh...!`);
    stranger.talk(`Bless you!`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_7);
    stranger.talk(`I'm sorry! I have to go!`);

    doWaitImageByTime(v8.V8AnnCorruptionLibrary_8);
    ann.talk(`Why are you in such a hurry?`);
    ann.talk(`Are you running from me?`);
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_9);
    stranger.talk(`N-no.`);
    ann.talk(`So where are you going?`);
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_10);
    stranger.talk(`N-Nowhere.`);
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_11);
    ann.talk(`Don't you like me?`);
    mc.think(`Now she is getting the hang of it...`);

    stranger.talk(`You... You are pretty, yes, pretty.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_12);
    ann.talk(`Do I bother you?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_11);
    stranger.talk(`N-No...`);

    doWaitImageByTime(v8.V8AnnCorruptionLibrary_13);
    ann.talk(`How about now?`);
    stranger.talk(`That's my private part!`);
    ann.talk(`Should I stop?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_14);
    stranger.talk(`I-If you want...`);
    ann.talk(`I don't want to...`);
    stranger.talk(`O-O-Okay.`);

    ann.talk(`Let's see what you are hiding there.`);
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_15);
    ann.talk(`Oh!`);
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_16);
    mc.think(`Wow... Ann is definitely taking this seriously.`);

    ann.talk(`It's soft...`);
    stranger.talk(`I- I'm sorry.`);
    ann.talk(`Don't apologize.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_17);
    ann.talk(`Let's try this.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_18);
    ann.talk(`Oh...`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_19);
    ann.talk(`It went in!`);
    stranger.talk(`I- It's not used of getting touched...`);
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_20);
    ann.talk(`But what if I do this...?`);
    stranger.talk(`Ahahah...`);
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_21);
    ann.talk(`Look at this!`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_22);
    ann.talk(`How does this feel?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_23);
    stranger.talk(`G- Great.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_22);
    ann.talk(`Should I continue?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_23);
    stranger.talk(`Y- Yes.`);

    ann.talk(`I-I can't believe this is happening!`);
    // TODO: animate this
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_24, { wait: 1 });
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_25, { wait: 1 });
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_24, { wait: 1 });
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_25, { wait: 1 });
    stranger.talk(`Mother of G-God!`);
    doImageShake(v8.V8AnnCorruptionLibrary_26);
    ann.talk(`Holy!`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_27);
    stranger.talk(`SORRY!`);
    ann.talk(`It's fine!`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_68);
    stranger.talk(`IT'S NOT FINE I APOLOGIZE!`);
    await endReplay(replayScenesList.v8annLibraryGuy);
    return jump(V8AnnCorruptionLibrary_AfterPicking, "V8AnnCorruptionLibrary_AfterPicking");
};
export const V8AnnCorruptionLibrary_PickedGirl = async (): Promise<any> => {
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_0);
    mc.think(`This is going to be a real challenge for Ann, I'm not even sure she is into girls.`);
    mc.think(`But I guess we are about to find out!`);
    mc.talk(`Alright, so this is the plan.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_32);
    mc.talk(`See the girl over there?`);
    ann.talk(`Yes, I actually know her.`);
    mc.talk(`So it should give you some advantage.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_52);
    ann.talk(`So, what about her?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_54);
    mc.talk(`You are going to go over there, and try to hit on her.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_55);
    ann.talk(`What? Are you serious? But she is a girl!`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_56);
    mc.talk(`So?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_59);
    ann.talk(`Who says she is into that?`);
    ann.talk(`And what about me?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_56);
    mc.talk(`You don't have to be into her, that's where the acting part comes into play.`);

    mc.talk(`What if you get a role that you are not comfortable with, or it's not how you'd normally behave?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_58);
    ann.talk(`...`);
    ann.talk(`You have a point.`);

    ImageClass.setImage(v8.V8AnnCorruptionLibrary_59);
    ann.talk(`Okay, I'll do it... But I'm telling you, it's not going to work.`);
    mc.talk(`Why are you so sure?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_57);
    ann.talk(`Because I know her, she is a loner, I don't even know her name.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_56);
    mc.talk(`I bet she's a freak in bed.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_58);
    ann.talk(`I don't know about that...`);

    ImageClass.setImage(v8.V8AnnCorruptionLibrary_56);
    mc.talk(`Think about that as your ultimate test.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_55);
    ann.talk(`But... How do I know when to stop or to keep pushing?`);
    mc.talk(`Easy.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_60);
    empty.think(`*Click*`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_61);
    ann.talk(`Oh!!!`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_62);
    ann.talk(`I can't believe I almost forgot I have this thing inside of me.`);

    ImageClass.setImage(v8.V8AnnCorruptionLibrary_53);
    ann.talk(`Ok, I think I'm ready.`);
    await strangerFemale.set((properties) => {
        strangerFemale.name = "Nerd Girl";
    });

    doWaitImageByTime(v8.V8AnnCorruptionLibrary_33);
    mc.think(`I honestly have no idea if she'll be able to pull this off.`);
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_34);
    ann.talk(`Hey...`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_35);
    strangerFemale.talk(`Hey...?`);
    ann.talk(`I hope I'm not bothering you. I've seen you around the library a lot and just wanted to come say hi. I'm Ann.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_36);
    strangerFemale.talk(`Oh... That's nice of you!`);
    await strangerFemale.set((properties) => {
        strangerFemale.name = "Sarah";
    });
    strangerFemale.talk(`My name is ${strangerFemale.name}.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_35);
    ann.talk(`I know this is a bit random, but I was wondering if you could help me out with something.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_69);
    strangerFemale.talk(`Sure, what do you need help with?`);
    // TODO: V8AnnCorruptionLibrary_69 smiling mouth close
    // ImageClass.setImage(v8.V8AnnCorruptionLibrary_69);
    ann.talk(`Well, I have this paper due for my literature class and I can't seem to find any good sources...`);
    ann.talk(`Since you seem like the smartest person around here I figured I could use your help.`);

    ann.talk(`If you agree of course!`);

    ImageClass.setImage(v8.V8AnnCorruptionLibrary_69);
    strangerFemale.talk(`Ah... I don't consider myself to be the smartest person but I'll do what I can.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_70);
    strangerFemale.talk(`Actually... If I knew better I'd say you are the smartest person here...`);
    strangerFemale.talk(`Also... It's been a while since I've seen you here...`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_71);
    ann.talk(`Oh... You noticed me?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_70);
    strangerFemale.talk(`Ah... Yes you came here every day...`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_72);
    strangerFemale.talk(`I... I actually wanted to say hey to you a few times...`);
    strangerFemale.talk(`Since we were both here every day I figured we could be... Friends or something.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_71);
    ann.talk(`Oh... It doesn't matter because we are talking now!`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_69);
    strangerFemale.talk(`Hee... Yes, that's true.`);
    mc.think(`She is definitely into Ann!`);
    mc.think(`This might be easier than I thought.`);
    strangerFemale.talk(`And... I like your outfit by the way.`);
    // TODO: V8AnnCorruptionLibrary_69 with close mouth
    ann.talk(`Thank you!`);
    strangerFemale.talk(`It's different from what I remember you wearing...`);
    ann.talk(`Hehe... Yeah, I'm trying out some different stuff lately.`);
    strangerFemale.talk(`That's nice!`);

    await mc.setQuestion(new Question({ text: `She did pretty well, but maybe it's time to let her know she should go further.`, options: { think: true }, key: `v8AnnCorLibraryLickNerdGirl` })
        .option({ title: `Hit the buzzer`, key: true })
        .option({ title: `Let her be`, key: false }));


    if (Question.globalAnswers.v8AnnCorLibraryLickNerdGirl) {

        return jump(V8AnnCorruptionLibrary_PickedGirl_Encourage, "V8AnnCorruptionLibrary_PickedGirl_Encourage");
    }

    ann.talk(`Well, it was really nice meeting you!`);
    strangerFemale.talk(`Likewise!`);

    await endReplay();

    return jump(V8AnnCorruptionLibrary_AfterPicking, "V8AnnCorruptionLibrary_AfterPicking");

};
export const V8AnnCorruptionLibrary_PickedGirl_Encourage = async (): Promise<any> => {
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_63);
    empty.think(`*Click*`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_73);
    ann.talk(`Ohh..!`);
    strangerFemale.talk(`What happened? Is everything alright?`);
    // TODO: V8AnnCorruptionLibrary_71 but with a big smile
    ann.talk(`Yes, yes.`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_71);
    ann.talk(`Say... Would you mind helping me find a book?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_69);
    strangerFemale.talk(`Sure! What book?`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_74);
    ann.talk(`Follow me, I'm sure it should be at the end there.`);

    doWaitImageByTime(v8.V8AnnCorruptionLibrary_75);
    strangerFemale.talk(`W... What are we doing?`);
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_76);
    ann.talk(`Shh...`);
    strangerFemale.talk(`A-Ann...?`);
    ann.talk(`I just want to check something...`);
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_37);
    mc.think(`Now we are talking!`);

    strangerFemale.talk(`Oh my god!`);
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_38);
    strangerFemale.talk(`Ann... W- What are you doing?`);
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_39);
    ann.talk(`*Lick*`);

    doWaitImageByTime(v8.V8AnnCorruptionLibrary_40);
    strangerFemale.talk(`Please! Don't stop.`);
    doWaitImageByTime(v8.V8AnnCorruptionLibrary_41);
    strangerFemale.talk(`I... I can't!`);
    doImageShake(v8.V8AnnCorruptionLibrary_42);
    ann.talk(`Oh my!`);
    strangerFemale.talk(`I'm so sorry!!!`);
    strangerFemale.talk(`That never happened before!`);
    ImageClass.setImage(v8.V8AnnCorruptionLibrary_43);
    strangerFemale.talk(`I-I'll talk to you later!`);
    await endReplay(replayScenesList.v8annLibraryGirl);


    return jump(V8AnnCorruptionLibrary_AfterPicking, "V8AnnCorruptionLibrary_AfterPicking");
};
export const V8AnnCorruptionLibrary_AfterPicking = async (): Promise<any> => {

    if (Question.globalAnswers.v8AnnCorLibraryBJNerdGuy || Question.globalAnswers.v8AnnCorLibraryLickNerdGirl) {
        if (Question.globalAnswers.v8AnnCorLibraryBJNerdGuy) {
            doWaitImageByTime(v8.V8AnnCorruptionLibrary_28);
            mc.talk(`Wow...`);
            ann.talk(`Hehe...`);
            mc.talk(`You still have something on your glasses`);
            ImageClass.setImage(v8.V8AnnCorruptionLibrary_29);
            ann.talk(`Where?`);
            ImageClass.setImage(v8.V8AnnCorruptionLibrary_30);
            ann.talk(`Oh.`);
            ann.talk(`Oops!`);
            ImageClass.setImage(v8.V8AnnCorruptionLibrary_31);
            ann.talk(`There.`);
            ImageClass.setImage(v8.V8AnnCorruptionLibrary_77);
            mc.talk(`I must say... I'm honestly surprised.`);
            ImageClass.setImage(v8.V8AnnCorruptionLibrary_31);
            ann.talk(`Does that mean I did well?`);
            ImageClass.setImage(v8.V8AnnCorruptionLibrary_77);
            mc.talk(`More than well... I can't believe you actually went through with this.`);
            ann.talk(`Me too!`);
            ImageClass.setImage(v8.V8AnnCorruptionLibrary_77.partials.V8AnnCorruptionLibrary_77_p);
            ann.talk(`I can't lie... I kinda enjoyed it...`);
            ann.talk(`For the first time, I felt like I was walking in Vanessa's shoes.`);
            // TODO: maybe add some thoughts or suggestions for Ann telling her to try and act like someone she knows (foreshadow for this line below)
            mc.talk(`I figured that that's what you were going with.`);

        }
        if (Question.globalAnswers.v8AnnCorLibraryLickNerdGirl) {
            doTransition(v8.V8AnnCorruptionLibrary_44);
            ann.talk(`I can't believe she peed on me!`);
            ImageClass.setImage(v8.V8AnnCorruptionLibrary_46);
            mc.talk(`Haha, she didn't pee on you...`);
            mc.talk(`You had a squirter on your hand.`);
            ImageClass.setImage(v8.V8AnnCorruptionLibrary_45);
            ann.talk(`A what?`);
            mc.talk(`She squirted...`);
            mc.talk(`Some girls do that... It's like when guys cum.`);
            ImageClass.setImage(v8.V8AnnCorruptionLibrary_46);
            ann.talk(`Oh...`);
            ann.talk(`So that means she really enjoyed that?`);
            mc.talk(`You bet.`);

            mc.talk(`I told you she must be a horny girl underneath that shell. She didn't even wear panties.`);
            ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_46.partials.V8AnnCorruptionLibrary_46_p);
            ann.talk(`Yes, you were definitely right!`);
            ImageClass.setImage(v8.V8AnnCorruptionLibrary_46);
            // ann.talk(`So? What's my grade?`);
            // mc.talk(`That's an A plus!`);
            // ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_46.partials.V8AnnCorruptionLibrary_46_p);
            // ann.talk(`Hehe.`);
            // ann.talk(`I still can't believe I actually did it!`);
            // mc.talk(`Me neither!`);

        }
        ann.talk(`So? What's my grade?`);
        mc.talk(`That's an A plus!`);
        if (Question.globalAnswers.v8AnnCorLibraryLickNerdGirl) {

            ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_46.partials.V8AnnCorruptionLibrary_46_p);
        }
        ann.talk(`Hehe.`);
        ann.talk(`I still can't believe I actually did it!`);
        mc.talk(`Me neither!`);

        if (Question.globalAnswers.v8AnnCorLibraryLickNerdGirl) {
            mc.talk(`I had no idea you are into girls as well.`);
            ann.talk(`Hehe.`);
            ann.talk(`You told me to try and be someone I'm not...`);
            mc.talk(`That's true, but still, I didn't expect you to lick her pussy.`);
            ann.talk(`I tried to think what Vanessa would do...`);
            mc.talk(`So you played that out perfectly because that's exactly what she would have done.`);
        }

    } else {
        if (Question.globalAnswers.v8AnnCorLibraryWhoPicked === "guy") {
            doWaitImageByTime(v8.V8AnnCorruptionLibrary_68);
            ann.talk(`...`);
            doWaitImageByTime(v8.V8AnnCorruptionLibrary_77);
            mc.talk(`You totally scared him away.`);

        } else {
            doWaitImageByTime(v8.V8AnnCorruptionLibrary_43);
            ann.talk(`...`);
            doWaitImageByTime(v8.V8AnnCorruptionLibrary_77);
            mc.talk(`You totally scared her away.`);
        }
        ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_31);
        ann.talk(`Hehe.`);
        ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_77.partials.V8AnnCorruptionLibrary_77_p, { putParent: true });
        ann.talk(`It was fun!`);
        ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_31);
        ann.talk(`How did I do?`);
        ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_77);
        mc.talk(`You did perfectly fine!`);
        mc.talk(`But now I'm curious what would you have done if I kept pushing you.`);
        ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_31);
        ann.talk(`Hehe, I have no idea... I might have tried something... But it's history now.`);
        ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_77);
        mc.talk(`I agree`);
    }

    if (!Question.globalAnswers.v8AnnCorLibraryLickNerdGirl) {
        ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_31);
    }
    ann.talk(`Are you ready to leave or do you have any more tests for me?`);
    if (!Question.globalAnswers.v8AnnCorLibraryLickNerdGirl) {
        ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_77);
    }
    mc.talk(`I think it's enough for one day.`);
    if (!Question.globalAnswers.v8AnnCorLibraryLickNerdGirl) {
        ImageClass.setImage(images.v8.V8AnnCorruptionLibrary_31);
    }
    ann.talk(`Alright! Let's go!`);


    return jump(V8AnnCorruptionLibrary_Home, "V8AnnCorruptionLibrary_Home");
};

export const V8AnnCorruptionLibrary_Home = async (): Promise<any> => {
    doTransition(v8.V8AnnCorruptionAfterLibraryRoom_9);
    ann.talk(`Hehe, I still can't believe I did that!`);
    if (Question.globalAnswers.v8AnnCorLibraryLickNerdGirl) {
        ImageClass.setImage(v8.V8AnnCorruptionAfterLibraryRoom_10);
        mc.talk(`Yeah... Going down on that girl was definitely wild!`);
    } else if (Question.globalAnswers.v8AnnCorLibraryBJNerdGuy) {
        ImageClass.setImage(v8.V8AnnCorruptionAfterLibraryRoom_10);
        mc.talk(`Yeah... Giving a blowjob to that guy was definitely wild!`);
    }

    ImageClass.setImage(v8.V8AnnCorruptionAfterLibraryRoom_9);
    ann.talk(`You know, I got used to this thing inside of me.`);
    ImageClass.setImage(v8.V8AnnCorruptionAfterLibraryRoom_11);
    ann.talk(`But I think it's time to take it out.`);
    ImageClass.setImage(v8.V8AnnCorruptionAfterLibraryRoom_10);
    mc.talk(`Yeah, I agree.`);
    mc.talk(`Lean on the table.`);
    doWaitImageByTime(v8.Anim_V8AnnCorruptionAfterLibraryRemovingPlug.poster);
    mc.talk(`Ready?`);
    ann.talk(`Hehe, go for it!`);
    ImageClass.setAnimation(images.v8.Anim_V8AnnCorruptionAfterLibraryRemovingPlug, { loop: 0, hideText: true, wait: true });
    ann.talk(`Hehe, now I feel like something is missing.`);
    ImageClass.setImage(images.v8.Last_V8AnnCorruptionAfterLibraryRemovingPlug);
    ann.talk(`I feel so empty.`);

    await mc.setQuestion(new Question({ text: `Empty she said...`, options: { think: true }, key: `v8AnnCorAfterLibraryFuckHerAss` })
        .option({ title: `Try to fuck her ass`, key: true })
        .option({ title: `Leave her be`, key: false }));

    if (Question.globalAnswers.v8AnnCorAfterLibraryFuckHerAss) {
        return jump(V8AnnCorruptionLibrary_Home_AssFuck, "V8AnnCorruptionLibrary_Home_AssFuck");

    }

    return jump(V8AnnCorruptionLibrary_Home_NoAssFuck, "V8AnnCorruptionLibrary_Home_NoAssFuck");
};

export const V8AnnCorruptionLibrary_Home_AssFuck = async (): Promise<any> => {
    doWaitImageByTime(v8.V8AnnCorruptionAfterLibraryRoom_1);
    mc.think(`She made me so horny today I gotta try it.`);
    doWaitImageByTime(v8.V8AnnCorruptionAfterLibraryRoom_2);
    ann.talk(`Oh!`);
    doWaitImageByTime(v8.V8AnnCorruptionAfterLibraryRoom_1);
    ann.talk(`Hehe, I was joking about feeling empty, you don't have to put it back inside.`);
    doWaitImageByTime(v8.V8AnnCorruptionAfterLibraryRoom_2);
    ann.talk(`Wait... It feels different!`);
    doWaitImageByTime(v8.V8AnnCorruptionAfterLibraryRoom_3);
    ann.talk(`It's definitely bigger!`);
    doWaitImageByTime(v8.V8AnnCorruptionAfterLibraryRoom_4);
    ann.talk(`Oh my!`);
    doWaitImageByTime(v8.V8AnnCorruptionAfterLibraryRoom_5, { wait: true });
    doWaitImageByTime(v8.V8AnnCorruptionAfterLibraryRoom_6);
    ann.talk(`Ouch!`);
    mc.talk(`Does it hurt?`);
    ImageClass.setImage(v8.V8AnnCorruptionAfterLibraryRoom_7);
    ann.talk(`Yeah. A bit.`);
    mc.talk(`Alright, that's enough for today.`);
    ImageClass.setImage(v8.V8AnnCorruptionAfterLibraryRoom_12);
    mc.talk(`I hope I didn't hurt you too much.`);
    ImageClass.setImage(v8.V8AnnCorruptionAfterLibraryRoom_13);
    ann.talk(`Hehe, no! I feel good but I think it needs more work and practice.`);
    ann.talk(`It's so kinky!`);
    ImageClass.setImage(v8.V8AnnCorruptionAfterLibraryRoom_14);
    mc.talk(`You turned me on so much today I couldn't help myself.`);
    ImageClass.setImage(v8.V8AnnCorruptionAfterLibraryRoom_13);
    ann.talk(`Hehe.`);

    return jump(V8AnnCorruptionLibrary_Home_2, "V8AnnCorruptionLibrary_Home_2");
};
export const V8AnnCorruptionLibrary_Home_NoAssFuck = async (): Promise<any> => {
    mc.think(`Even though I'm fucking horny I'll leave her be for now.`);
    mc.think(`Besides, I don't think her ass is ready for my cock just yet... She needs more practice.`);
    doWaitImageByTime(v8.V8AnnCorruptionAfterLibraryRoom_12);
    ann.talk(`I couldn't believe I'd get used to it! But I did!`);

    return jump(V8AnnCorruptionLibrary_Home_2, "V8AnnCorruptionLibrary_Home_2");
};
export const V8AnnCorruptionLibrary_Home_2 = async (): Promise<any> => {
    //ImageClass.setImage(images.TODO_IMAGE)
    // if (Question.globalAnswers.V8AnnDateMCOkWithChris) {
    //     ann.talk(`By the way, Are you going to come with me to Chris's place?`);
    //     mc.talk(`I don't.`);
    //     ann.talk(`Chris invited me over to his place, and he said that you are invited.`);
    //     ann.talk(`Would you like to come?`);
    //     mc.talk(`Mmm...`);
    //     mc.talk(`I'll have to see.`);
    //     ann.talk(`Well, you should!`);
    //     mc.talk(`What have you guys planned?`);
    //     ann.talk(`Nothing really... Just watching a movie, like we did with Emily.`);
    //     mc.talk(`Sounds like something you both should be doing alone, no?`);
    //     ann.talk(`He insisted that I'd invite you!`);
    //     mc.talk(`Really?`);
    //     ann.talk(`I swear!`);
    //     ann.talk(`Just think about that and I'll go get ready and text you later to see if you are interested.`);
    //     mc.talk(`Sounds great.`);
    //     ann.talk(`Hehe.`);
    //     ann.talk(`Alright! I'll talk to you later then. Bye!`);


    // } else {
    //     ann.talk(`Alright, I'm gonna take a shower and get some rest, it's been a long day.`);
    //     mc.talk(`Talk to you tomorrow!`);
    //     ann.talk(`Hehe, bye bye!`);
    // }

    emily.talk(`${mc.name.toUpperCase() + mc.name.slice(-1).toUpperCase().repeat(3)}!`, { method: "Shouting" });
    mc.talk(`I think Emily is ready for us.`);
    mc.talk(`Are you ready?`);
    ann.talk(`Hehe, Yes.`);

    return jump(V8AnnCorruptionLibraryAfter, "V8AnnCorruptionLibraryAfter");
};

